import Modal from "react-modal";
import React, {useEffect, useState} from "react";
import './Variz.css'
import axios from "axios";
import data from "bootstrap/js/src/dom/data";
import {useMediaQuery} from "beautiful-react-hooks";
import Toast from "./Tost";
import { toast, ToastContainer } from "react-toastify";


const NUMBER1 = "1000000"

export default function ({modalIsOpen,Openchanger}){

    const [carts,setcarts] = useState([])
    const [amount,setamount] = useState('')
    const [loadingp,setLoadingp] = useState(false)

    let phone = sessionStorage.getItem('user')
    let token = localStorage.getItem('TOKEN')
    const isSmall = useMediaQuery('(max-width: 1000px)')
    const [message,setmessage] = useState('')
    const [type,settype] = useState('')

    const customStylesDesktop = {
        overlay: {
      position: 'fixed',
                  zIndex: 1020,
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  background: 'rgba(0,0,0, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',


    },

          content: {
           background: '#FFFFFF',
                  width: '60rem',
                  maxWidth: 'calc(150vw - 2rem)',
                  maxHeight: 'calc(95vh - 2rem)',
                  border:'0px',
                  overflowY: 'auto',
                  position: 'relative',
                  borderRadius: '0.6rem',
                  background: '#FDFCFF',
                  boxShadow: '0px 4px 16px rgba(8, 44, 95, 0.16)',
                  borderRadius: '32px'




          },


};

const customStylesMobile = {
    overlay: {
  position: 'fixed',
              zIndex: 1020,
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(131, 131, 131, 0.13)',
              display: 'flex',
              justifyContent: 'center',
              backdrop: 'blur(1.5px)',
              


},

      content: {
       background: '#FFFFFF',
              width: '34rem',
              maxWidth: 'calc(150vw - 2rem)',
              maxHeight: 'calc(92vh - 1rem)',
              overflowY: 'auto',
              position: 'relative',
              borderRadius: '0.4rem',
              inset:'0px',
              margin : '2vh 2px 2px 2px',
              boxShadow: '0px 2.61792px 7.85375px rgba(8, 44, 95, 0.2)',
              borderRadius:'15px',
              height:'658px',
              margin: '40px 0px 0px 0px'




      },


};



    Modal.setAppElement('#root');




    let subtitle;
    function afterOpenModal() {
  }
   function closeModal() {
        Openchanger(false)

  }
  function handelprice(event){

     setamount(event.target.value)


      document.getElementById('amount').value = new Intl.NumberFormat("fa").format(event.target.value)



  }


  useEffect(async ()=>{


      await axios.get('https://api.sinatether.com/Auth/CartEhraz/',{
              params:{phone},

              withCredentials:true

      }).then((response)=>{
          if (response.status==200)
          {
              setcarts(response.data['carts'])

          }
      }).catch((error)=>{
          if (error){
           
          }
      })

  },[])




    function handelpayment(){


        if(!amount){
            settype("error")
            setmessage("لطفا مبلغ مورد نظر خود را وارد نمایید")
        }

        setLoadingp(true)

        axios.post('https://api.sinatether.com/Auth/payment/',
            {'amount': amount, 'phone': phone},{
         withCredentials:true,
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }}).then((res)=>{
            console.log(res)
            let Variztoken = res.data['trx']
            console.log(Variztoken)
                if (Variztoken){
                    window.location.assign(res.data['url']);

                }

                setLoadingp(false)


        }).catch((error)=>{
            if (error){
          

                setLoadingp(false)
            }
        })
    }


    let num;






    


    function separateNum(event) {
        let value = event.target.value
        var nStr = value + '';
        nStr = nStr.replace(/\,/g, "");
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        if (event !== undefined) {
            event.target.value = x1 + x2;
            ex_normalNum(event.target.value)
        } else {
            return x1 + x2;
        }
    }



    function ex_normalNum(num) {
            num = num.replace(/,\s?/g, "");
            setamount(num);
            console.log(amount)
        }



     function Gotolist() {
         window.location.replace('/ListVariz')
     }








  return(
      <>
        <Toast type={type} message={message}/>
      {isSmall ?
              <Modal
                    isOpen={modalIsOpen}
                    onAfterOpen={afterOpenModal}
                    ariaHideApp={false}
                    style={customStylesMobile}
                    contentLabel="Example Modal"
                    backdrop= "static"

                  >

                      <div className={'container'} id={'mbody'}>
                          <div className={'title'}>
                              <span className="close" onClick={closeModal}>&times;</span>
                              <h4>واریز تومانی</h4>
                  <hr/>
                            

                          </div>

                          <div className={'row'}>
                              <form className={'col-md-7 '}>


                                  <label className={'text-large'}>مبلغ(تومان ) </label>
                                  <input id={'amount'} type={'input'} className={'form-control bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6 '} onKeyUp={separateNum} placeholder={'مبلغ خود را وارد کنید'}  />

                                  <br/>








                                  <div className={''}>
                                  <a href={'/ehzcart'} id={'abtn'} >
                                      <div class="row">
                                          <div className="col-1">
                                          <svg id="Group_27532" data-name="Group 27532" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
  <path id="Path_1" data-name="Path 1" d="M8.3,4.889a.292.292,0,0,0-.583,0V7.709H4.893a.292.292,0,1,0,0,.583H7.713v2.819a.292.292,0,1,0,.583,0V8.292h2.819a.292.292,0,0,0,0-.583H8.3Z" stroke="#000" stroke-width="1"/>
  <rect id="Rectangle_1" data-name="Rectangle 1" width="15" height="15" rx="3.5" transform="translate(0.5 0.5)" fill="none" stroke="#000" stroke-width="1"/>
</svg>

                                          </div>
                                          <div className="col-6 pl-3">
                                              <span className=" myheav text-large mytext-warning">
                                                  افزودن کارت جدید

                                              </span>

                                          </div>
                                      </div>

                                          </a>

                                  </div>



                              </form>

                          </div>
                    


                         <div className={'text-left btnvariz '}>
                             <br/>
                             <br/>

                            
                             <button className={'btn  btn-success btsubmit2020 '} data-inline={true} onClick={handelpayment}>{loadingp ? 

<i className="fa fa-spinner fa-spin loadIcon24 text-white"></i>


                                :
                                <>
                                پرداخت
                                
                                </>
                                
                                

                                }</button>

                         </div>


                                                                       
             <div className="card-tazakor hrgerbere">

<div>
   <div className="tewxtushe63">توجه !</div>
                 <span className="text-dark">در صورت واریز با کارت احراز نشده مبلغ واریزی بلوکه خواهد شد.</span>
             </div>


</div>

                      </div>




                  </Modal>

              :
                  <Modal
                    isOpen={modalIsOpen}
                    onAfterOpen={afterOpenModal}
                    ariaHideApp={false}
                    style={customStylesDesktop}
                    contentLabel="Example Modal"
                    backdrop= "static"

                  >

                      <div className={'container'} id={'mbody'}>
                          <div className={'title'}>
                              <span className="close" onClick={closeModal}>&times;</span>
                            


                          </div>

                          <div className={'row'}>
                              <form className={'col-md-7 card820820'}>

                                
                              <div className="titledesl820">واریز تومانی</div>

                                  <label className={'text-large'}>مبلغ(تومان)</label>
                                  <input id={'amount'} type={'tel'} className={'myinput_form form-control bg-custom-input myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6'} onKeyUp={separateNum} placeholder={''}  />
                                  <div className={'pt-2'}>

                                  <button type={'button'} className={'btn btn-outline-dark mt-10 btnkksfhgfsfs'} value={1000000} onClick={handelprice}>1,000,000تومان</button>
                                   &nbsp;
                                  <button type={'button'} className={'btn btn-outline-dark btnkksfhgfsfs'} value={5000000} onClick={handelprice}>5,000,000تومان</button>
                                   &nbsp;
                                  <button type={'button'} className={'btn btn-outline-dark btnkksfhgfsfs'} value={10000000} onClick={handelprice}>10,000,000تومان</button>
                                   </div>





                                  <br/>








                                  <div className={''}>
                                  <a href={'/ehzcart'} id={'abtn'} >
                                      <div class="row">
                                          <div className="col-1">
                                          <svg id="Group_27532" data-name="Group 27532" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
  <path id="Path_1" data-name="Path 1" d="M8.3,4.889a.292.292,0,0,0-.583,0V7.709H4.893a.292.292,0,1,0,0,.583H7.713v2.819a.292.292,0,1,0,.583,0V8.292h2.819a.292.292,0,0,0,0-.583H8.3Z" stroke="#000" stroke-width="1"/>
  <rect id="Rectangle_1" data-name="Rectangle 1" width="15" height="15" rx="3.5" transform="translate(0.5 0.5)" fill="none" stroke="#000" stroke-width="1"/>
</svg>
                                             
                                          </div>
                                          <div className="col-6 pl-1 pt-1">
                                              <span className=" myheav text-large mytext-warning">
                                                  افزودن کارت جدید

                                              </span>

                                          </div>
                                      </div>

                                          </a>

                                  </div>

                                  
                         <div className={'text-center btnvariz '}>
                             <br/>
                             <br/>

                             <button type="button" className={'btn  btn-success btsubmit2020 djjsgfyg343535 '} data-inline={true} onClick={handelpayment}>
                                {loadingp ? 

<i className="fa fa-spinner fa-spin loadIcon24 text-white"></i>


                                :
                                <>
                                پرداخت
                                
                                </>
                                
                                

                                }
                                
                                </button>

                         </div>



                              </form>
                              <form className={'col-5'}>
                                                  
             <div className="card-tazakor hrgerbere">

<div>
   <div className="tewxtushe63">توجه !</div>
                 <span className="text-dark">در صورت واریز با کارت احراز نشده مبلغ واریزی بلوکه خواهد شد.</span>
             </div>


</div>

                              </form>

                          </div>



                      </div>




                  </Modal>
      }
            </>


  )
}